import type React from "react";
import { memo } from "react";

interface HeaderProps {
	status: string;
	statusType: "ready" | "running" | "error";
	isPaused: boolean;
}

/**
 * Header component, memoized with explicit props to avoid unrelated context-driven re-renders.
 */
export const Header: React.FC<HeaderProps> = memo(
	({ status, statusType, isPaused }) => {
		return (
			<header className="bg-card-bg border-b border-border-main px-4 sm:px-6 py-3 flex justify-between items-center gap-4 relative z-[100]">
				<h1 className="text-lg sm:text-xl font-bold tracking-tight whitespace-nowrap shrink-0">
					MONOLOG LIVE
				</h1>
				<div
					id="status-display"
					className="flex items-center gap-2 sm:gap-3 text-xs sm:text-sm text-text-dim min-w-0"
				>
					<div
						id="status-indicator"
						aria-hidden="true"
						className={`w-2 sm:w-2.5 h-2 sm:h-2.5 rounded-full shrink-0 ${
							statusType === "running"
								? isPaused
									? "bg-amber-500"
									: "bg-emerald-500 shadow-[0_0_0_0_rgba(16,185,129,0.7)] animate-pulse"
								: statusType === "error"
									? "bg-red-500"
									: "bg-slate-400"
						}`}
					></div>
					<span id="status-text" className="truncate font-medium">
						{status}
					</span>
				</div>
			</header>
		);
	},
);
